export type GoogleDriveIntegrationMetadata = {
  folderName: string
  folderId: string
  folderUrl: string
}

export type AccountIntegrationMetadata = {
  GOOGLE_DRIVE?: GoogleDriveIntegrationMetadata
}

export const INTEGRATION_METADATA_KEYS = {
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
} as const
